// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

// import Swiper and modules styles
import 'swiper/css/bundle';

// init Swiper:


document.addEventListener('DOMContentLoaded', () => {

    const swiper = new Swiper('.quotes-slider', {

        slidesPerView: 1,
        autoplay: {
            delay: 5000,
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});